export default __webpack_public_path__ + "static/media/12.4a2a6538.jpeg";